import {useCallback, useEffect, useState} from 'react';
import {apiFetch} from '../api';

export default function useGroups({initialGroups, onError}) {
    const [groups, setGroups] = useState([]);

    useEffect(() => {
        if (initialGroups) setGroups(initialGroups);
    }, [initialGroups]);

    const renameGroup = useCallback(async (id, name) => {
        try {
            await apiFetch(`/checklist-groups/${id}`, {
                method: 'PUT',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({name}),
            });
            setGroups(prev => prev.map(g => g.id === id ? {...g, name} : g));
        } catch (err) {
            onError(err);
        }
    }, [onError]);

    const createGroup = useCallback(async (name) => {
        try {
            const res = await apiFetch('/checklist-groups', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({name}),
            });
            const group = await res.json();
            setGroups(prev => [...prev, group]);
        } catch (err) {
            onError(err);
        }
    }, [onError]);

    const deleteGroup = useCallback(async (id) => {
        try {
            await apiFetch(`/checklist-groups/${id}`, {method: 'DELETE'});
            setGroups(prev => prev.filter(g => g.id !== id));
        } catch (err) {
            onError(err);
        }
    }, [onError]);

    const reorderGroups = useCallback((movedId, afterId, reorderedList) => {
        setGroups(reorderedList);
        apiFetch(`/checklist-groups/${movedId}`, {
            method: 'PUT',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({after: afterId, reorder: true}),
        }).catch(err => onError(err));
    }, [onError]);

    return {groups, createGroup, renameGroup, deleteGroup, reorderGroups};
}
